<template>
    <flex-element
        :element-type="elementType"
        class-default-inline="f-relative"
        :tag="renderedTag"
    >
        <slot :element="element" :elements-new="elementsNew" :element-updated="elementUpdated" />
    </flex-element>
</template>

<script>
import baseOrganism from '@/mixins/base-organism/base-organism-smart';

export default {
    name: 'o-container',
    mixins: [baseOrganism],

    props: {
        displayName: {
            type: String,
            default: 'Container',
        },

        tag: {
            type: String,
            default: 'div',
        },
    },

    data() {
        return {
            cssDisplay: 'block',
        };
    },

    computed: {
        renderedTag() {
            return this.tag || 'div';
        },
    },
};
</script>
